import React, {useState}					from 'react';

import Icon 								from '../Icon';

import {useAppSelector}						from '../../../app/hooks';
import {AddCardProps}						from './interface';

import LANGUAGE								from '../../language';

import './AddCard.css';
import Badge from '../Badge';


export default function AddCard(props: AddCardProps): JSX.Element {
	const lang = useAppSelector(state => state.settings.lang);

	const [hover, set_hover] = useState('');

	const TEXTE = LANGUAGE(lang);

	if (!props.image) {
		return (
			<div
				onClick={props.onClick}
				className={'addCardMinimizeContainer'}
			>
				<div
					className={'addCardMinimizeIconContainer'}
					style={props.backgroundColorIcon ? {backgroundColor: props.backgroundColorIcon} : {}}
				>
					<Icon
						iconSize={24}
						icon={props.icon}
						iconColor={props.iconColor}
					/>
				</div>
				<div className={'addCardMinimizeTextContainer'}>
					<span className={'text-md weight-600 gray-700'}>{props.title}</span>
					<span className={'text-regular weight-400 gray-600'}>{props.text}</span>
				</div>
			</div>
		);
	}

	return (
		<div
			className={'addCardContainer'}
			onMouseEnter={() => set_hover('hover')}
			onMouseLeave={() => set_hover('not-hover')}
			style={props.soon ? {cursor: 'not-allowed'} : {}}
			onClick={() => (!props.soon ? props.onClick() : undefined)}
		>
			<div
				className={`addCardImage ${hover}`}
				style={{backgroundImage: `url('${props.image}')`}}
			/>

			<div className={'addCardTextContainer'}>
				<div
					className={'addCardIconContainer'}
					style={props.backgroundColorIcon ?
						{backgroundColor: props.backgroundColorIcon, boxShadow: `0 0 10px ${props.backgroundColorIcon}`}
						:
						{}
					}
				>
					<Icon
						iconSize={24}
						icon={props.icon}
						iconColor={props.iconColor}
					/>
				</div>

				{props.soon &&
					<div style={{display: 'flex', alignSelf: 'center'}}>
						<Badge color={'gray'} text={TEXTE.global.soon} />
					</div>
				}
				<span className={'gray-700'}>{props.title}</span>
				<span>{props.text}</span>
			</div>
		</div>
	);
}